<template>
    <div>
        <transition name="fade" mode="out-in">
            <div :class="css" v-if="! (hide && isMobile)">
                <inserate/>
                <konto/>
                <umsatz/>
                <service/>
                <kontakt/>
            </div>
        </transition>
    </div>
</template>

<script>
    import Inserate          from './nav-components/Inserate';
    import Konto             from './nav-components/Konto';
    import Umsatz            from './nav-components/Umsatz';
    import Service           from './nav-components/Service';
    import Kontakt           from './nav-components/Kontakt';
    import { IsMobileMixin } from '../../mixins/IsMobile'; 
    import EventBus          from '../../EventBus';

    export default {
        data() {
            return {
                hide: true,
            }
        },
        computed: {
            css() {
                return {
                    'm-top': this.isMobile
                };
            }
        },
        mixins: [IsMobileMixin],
        components: {
            Inserate,
            Konto,
            Umsatz,
            Service,
            Kontakt,
        },
        methods: {
            toggleMenu(state = '') {
                if(state != '') {
                    this.hide = state == 'hide' ? true : false;
                }else {                        
                    this.hide = !this.hide;
                }
            }
        },
        created() {
            EventBus.$on('TOGGLE_MENU', this.toggleMenu);
        },
        beforeDestroy() {
            EventBus.$off('TOGGLE_MENU', this.toggleMenu);
        }
    }
</script>

<style scoped>
.hide  {
    display: none;
}
.m-top{
    margin-top: -35px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>